// Angular
import { Component } from '@angular/core';
// Model
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	selector: 'cv-dm-license-dialog',
	templateUrl: './dm-license-dialog.component.html',
	styleUrls: ['./dm-license-dialog.component.scss']
})
export class DMLicenseDialogComponent {

	public isDMLicensed = false;

	constructor(
		public config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef
	) {
		this.isDMLicensed = this.config.data.isDMLicensed;
	}

	/**
	 * Close the Dialog
	 */
	public closeDialog() {
		this.dialogRef.close();
	}
}
